<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400">
    <path
      fill="currentColor"
      class="cls-2"
      d="M281.43,144.02h-86.39c-4.74,0-8.58-3.84-8.58-8.58V65.06c0-4.74-3.84-8.58-8.58-8.58H104.64c-4.74,0-8.58,3.84-8.58,8.58V324.81c0,4.74,3.84,8.58,8.58,8.58h73.23c4.74,0,8.58-3.84,8.58-8.58v-115c0-6,4.87-10.87,10.87-10.87h5.72c6,0,10.87,4.87,10.87,10.87v115c0,4.74,3.84,8.58,8.58,8.58h73.23c4.74,0,8.58-3.84,8.58-8.58V166.9c0-12.64-10.25-22.89-22.89-22.89Z"
    />
  </svg>
</template>
